module.exports = __webpack_public_path__ + "img/report-8.1a81538a.jpg";